import { Component, Input } from '@angular/core';
import { FiltersComponent } from '../../common/filters.component';
import { DateService } from '../../common/date.service';
import { Company, PostFilters } from '../post.model';

@Component({
	selector: 'app-post-filters',
	templateUrl: './post-filters.component.html',
	styleUrls: ['./post-filters.component.css'],
})
export class PostFiltersComponent extends FiltersComponent {
	@Input() taskStatuses: Array<any>;
	@Input() senders: Array<any>;
	@Input() users: Array<any>;
	@Input() received: Array<any>;
	@Input() companies: Company[];
	filters: PostFilters = {
		taskStatus: [],
		postSender: [],
		givenToPerson: [],
		createdBy: [],
		received_from: null,
		received_to: null,
		recipient: [],
	};

	protected filtersAfterLoad() {
		this.filters.taskStatus = ['1'];
	}

	filtersDefault() {
		this.filtersClear();
		const date = new DateService();
		this.filters.received_from = date.daysAdd(+0);
		this.filters.received_to = date.daysAdd(+14);
		this.filters.taskStatus = ['1'];
	}
}
